import React from "react";
import Sidebar from "../Sidebar";
import Route from "../Route";
import DashboardHomePage from "../DashboardHomePage";
import Investments from "../Investments";
import InvestmentsTFSA from "../InvestmentsTFSA";
import InvestmentsRRSP from "../InvestmentsRRSP";
import InvestmentsRRIF from "../InvestmentsRRIF";
import InvestmentsLIRA from "../InvestmentsLIRA";
import InvestmentsLIF from "../InvestmentsLIF";
import Revenue from "../Revenue";
import LifeStrategy from "../LifeStrategy";
import Expenses from "../Expenses";
import PersonalInfo from "../PersonalInfo";
import ChangePlanPage from "../ChangePlanPage";
import PasswordAndSecurityPage from "../PasswordAndSecurityPage";
import NonRegisteredPage from "../NonRegisteredPage";
import ExpenseBreakdownPage from "../ExpenseBreakdownPage";

const MainScreen = () => {

    return(
        <div>
        <Sidebar />
            <Route path="/">
                <DashboardHomePage />
            </Route>
            <Route path="/investments">
                <Investments />
            </Route>
            <Route path="/investment-tfsa-page">
                <InvestmentsTFSA />
            </Route>
            <Route path="/revenue">
                <Revenue />
            </Route>
            <Route path="/lifestrategy">
                <LifeStrategy />
            </Route>
            <Route path="/expenses">
                <Expenses />
            </Route>
            <Route path="/profile">
                <PersonalInfo />
            </Route>
            <Route path="/changeplan">
                <ChangePlanPage />
            </Route>
            <Route path="/password-and-security">
                <PasswordAndSecurityPage />
            </Route>
            <Route path="/non-reg-page">
                <NonRegisteredPage />
            </Route>
            <Route path="/rrsp-page">
                <InvestmentsRRSP />
            </Route>
            <Route path="/lira-page">
                <InvestmentsLIRA />
            </Route>
            <Route path="/rrif-page">
                <InvestmentsRRIF />
            </Route>
            <Route path="/lif-page">
                <InvestmentsLIF />
            </Route>
            <Route path="/expense-breakdown-page">
                <ExpenseBreakdownPage />
            </Route>
        </div>
    )
}

export default MainScreen;